/*  */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_DEVICES',
  'UPDATE_DEVICE',
  'DELETE_DEVICE',
  'DELETE_ALL_DEVICES',
  'CREATE_DEVICE',
]);
